<template>
	<div>
		<div class="container-fluid">
			<form v-on:submit.prevent>

				<div class="form-group row">
					<label class="col-sm-3 col-form-label">
						Client Name
						<sup>*</sup>
					</label>
					<div class="col-sm-7 pr-5" >
						<multiselect
							v-model="clientData.client"
							:options="clientList"
							label="client_name"
							:searchable="true"
							ref="multiselect"
							track-by="client_name"
							open-direction="bottom"
							class="form-control multi-dropdown select_filter"
							placeholder="Client"
							selectLabel
							deselectLabel
							selectedLabel
							:showLabels="true"
							tagPlaceholder="Press enter to create new vendor"
							style="max-height:40px;"
							:multiple="false"
							id="mutiselect"
							:disabled="client_disable || openAddNewClientPopUp"
							:loading="isLoadingClient"
							:taggable="true"
							@select="selectNewClient"
							@tag="addNewClient"
						/>
					</div>
					<div class="col-md-2" v-if="$route.params.ProfileId">
						<button
							class="btn btn-primary"
							style="font-size: 12px;"
							@click="addNewClient(clientData.client.client_name, clientData.client.client_id, clientData.go_client_cd, 'edit')"
						>Edit Client Name</button>
					</div>
				</div>

				<div class="form-group row">
					<label class="col-sm-3 col-form-label">Director of Customer Marketing & Sales</label>
					<div class="col-sm-7 pr-5">
						<multiselect
							v-model="clientData.go_retail"
							:options="contacts_list"
							:searchable="true"
							@search-change="updateName"
							ref="multiselect"
							track-by="email"
							:custom-label="customLabel"
							open-direction="bottom"
							placeholder="Director of Customer Marketing & Sales"
							class="form-control multi-dropdown select_filter"
							selectLabel
							deselectLabel
							selectedLabel
							tagPlaceholder="Press enter to create new contact"
							autocomplete="off"
							style="max-height:40px;"
							:multiple="false"
							:loading="retailLoader"
							id="retail"
							:taggable="true"
							@select = "addNew($event,'retail', index)"
							@tag="addNew($event,'retail', index)"
						>
							<template slot="noResult">
								<div @click="addNew('retail', index)">Add new contact</div>
							</template>
						</multiselect>
					</div>
				</div>

				<div class="form-group row">
					<label class="col-sm-3 col-form-label">GO Account Manager</label>
					<div class="col-sm-7 pr-5">
						<multiselect
							v-model="clientData.client_main_contact"
							:options="contacts_list"
							:searchable="true"
							ref="multiselect"
							:custom-label="customLabel"
							label="first_name"
							track-by="email"
							open-direction="bottom"
							placeholder="GO Account Manager"
							class="form-control multi-dropdown select_filter"
							selectLabel
							deselectLabel
							selectedLabel
							autocomplete="off"
							style="max-height:40px;"
							:multiple="false"
							id="clsient"
							:loading="clientLoader"
							:taggable="true"
							tagPlaceholder="Press enter to create new contact"
							@select="addNew($event,'client', index)"
							@tag="addNew($event,'client', index)"
						>
							<template slot="noResult">
								<div @click="addNew('client', index)">Add new client contact</div>
							</template>
						</multiselect>
					</div>
				</div>
				
				<div class="form-group row">
					<label class="col-sm-3 col-form-label">Operations Contact</label>
					<div class="col-sm-7 pr-5">
						<multiselect
							v-model="clientData.go_ops"
							:options="contacts_list"
							:searchable="true"
							ref="multiselect"
							:custom-label="customLabel"
							label="first_name"
							track-by="email"
							open-direction="bottom"
							placeholder="GO operations contact"
							class="form-control multi-dropdown select_filter"
							selectLabel
							deselectLabel
							selectedLabel
							autocomplete="off"
							tagPlaceholder="Press enter to create new contact"
							style="max-height:40px;"
							:multiple="false"
							id="ops"
							:loading="opsLoader"
							:taggable="true"
							@select = "addNew($event,'ops', index)"
							@tag="addNew($event,'ops', index)"
						>
							<template slot="noResult">
								<div @click="addNew('ops', index)">Create new ops contact</div>
							</template>
						</multiselect>
					</div>
				</div>

				
				<div class="form-group row">
					<label class="col-sm-3 col-form-label">Brand Manager Contact</label>
					<div class="col-sm-7 pr-5">
						<multiselect
							v-model="clientData.go_brand"
							:options="contacts_list"
							:searchable="true"
							ref="multiselect"
							:custom-label="customLabel"
							label="first_name"
							track-by="email"
							open-direction="bottom"
							placeholder="GO brand manager contact"
							class="form-control multi-dropdown select_filter"
							selectLabel
							deselectLabel
							selectedLabel
							autocomplete="off"
							tagPlaceholder="Press enter to create new contact"
							style="max-height:40px;"
							:multiple="false"
							id="brand"
							:taggable="true"
							@select = "addNew($event,'brand', index)"
							@tag="addNew($event,'brand', index)"
						>
							<template slot="noResult">
								<div @click="addNew('brand', index)">Create new brand manager contact</div>
							</template>
						</multiselect>
					</div>
				</div>
				
				<div class="form-group row">
					<label class="col-sm-3 col-form-label">Marketing Specialist (Search) Contact</label>
					<div class="col-sm-7 pr-5">
						<multiselect
							v-model="clientData.go_marketing"
							:options="contacts_list"
							:searchable="true"
							ref="multiselect"
							:custom-label="customLabel"
							label="first_name"
							track-by="email"
							open-direction="bottom"
							placeholder="GO search contact"
							class="form-control multi-dropdown select_filter"
							selectLabel
							deselectLabel
							selectedLabel
							autocomplete="off"
							tagPlaceholder="Press enter to create new contact"
							style="max-height:40px;"
							:multiple="false"
							id="dsp"
							:taggable="true"
							@select = "addNew($event,'market', index)"
							@tag="addNew($event,'market', index)"
						>
							<template slot="noResult">
								<div @click="addNew('market', index)">Create new search contact</div>
							</template>
						</multiselect>
					</div>
				</div>

				<div class="form-group row">
					<label class="col-sm-3 col-form-label">Marketing Specialist (DSP) Contact</label>
					<div class="col-sm-7 pr-5">
						<multiselect
							v-model="clientData.go_dsp"
							:options="contacts_list"
							:searchable="true"
							ref="multiselect"
							:custom-label="customLabel"
							label="first_name"
							track-by="email"
							open-direction="bottom"
							placeholder="GO dsp contact"
							class="form-control multi-dropdown select_filter"
							selectLabel
							deselectLabel
							selectedLabel
							autocomplete="off"
							tagPlaceholder="Press enter to create new contact"
							style="max-height:40px;"
							:multiple="false"
							id="dsp"
							:taggable="true"
							@select = "addNew($event,'dsp', index)"
							@tag="addNew($event,'dsp', index)"
						>
							<template slot="noResult">
								<div @click="addNew('dsp', index)">Create new dsp contact</div>
							</template>
						</multiselect>
					</div>
				</div>

				<div class="form-group row">
					<label class="col-sm-3 col-form-label">Digital Media Coordinator</label>
					<div class="col-sm-7 pr-5">
						<multiselect
							v-model="clientData.go_media"
							:options="contacts_list"
							:searchable="true"
							ref="multiselect"
							:custom-label="customLabel"
							label="first_name"
							track-by="email"
							open-direction="bottom"
							placeholder="GO media contact"
							class="form-control multi-dropdown select_filter"
							selectLabel
							deselectLabel
							selectedLabel
							autocomplete="off"
							tagPlaceholder="Press enter to create new contact"
							style="max-height:40px;"
							:multiple="false"
							id="media"
							:taggable="true"
							@select = "addNew($event,'media', index)"
							@tag="addNew($event,'media', index)"
						>
							<template slot="noResult">
								<div @click="addNew('media', index)">Create new media contact</div>
							</template>
						</multiselect>
					</div>
				</div>

				<div class="form-group row">
					<label class="col-sm-3 col-form-label">Digital Content Specialist</label>
					<div class="col-sm-7 pr-5">
						<multiselect
							v-model="clientData.go_content"
							:options="contacts_list"
							:searchable="true"
							ref="multiselect"
							:custom-label="customLabel"
							label="first_name"
							track-by="email"
							open-direction="bottom"
							placeholder="GO content contact"
							class="form-control multi-dropdown select_filter"
							selectLabel
							deselectLabel
							selectedLabel
							autocomplete="off"
							tagPlaceholder="Press enter to create new contact"
							style="max-height:40px;"
							:multiple="false"
							id="content"
							:taggable="true"
							@select = "addNew($event,'content', index)"
							@tag="addNew($event,'content', index)"
						>
							<template slot="noResult">
								<div @click="addNew('content', index)">Create new content contact</div>
							</template>
						</multiselect>
					</div>
				</div>

				<div class="form-group row">
					<label class="col-sm-3 col-form-label">BA Contact</label>
					<div class="col-sm-7 pr-5">
						<multiselect
							v-model="clientData.go_ba"
							:options="contacts_list"
							:searchable="true"
							ref="multiselect"
							:custom-label="customLabel"
							label="first_name"
							track-by="email"
							open-direction="bottom"
							placeholder="GO BA contact"
							class="form-control multi-dropdown select_filter"
							selectLabel
							deselectLabel
							selectedLabel
							autocomplete="off"
							tagPlaceholder="Press enter to create new contact"
							style="max-height:40px;"
							:multiple="false"
							id="ba"
							:taggable="true"
							@select = "addNew($event,'ba', index)"
							@tag="addNew($event,'ba', index)"
						>
							<template slot="noResult">
								<div @click="addNew('ba', index)">Create new BA contact</div>
							</template>
						</multiselect>
					</div>
				</div>

				<div class="form-group row">
					<label class="col-sm-3 col-form-label">Other Contact</label>
					<div class="col-sm-7 pr-5">
						<multiselect
							v-model="clientData.go_other"
							:options="contacts_list"
							:searchable="true"
							ref="multiselect"
							:custom-label="customLabel"
							label="first_name"
							track-by="email"
							open-direction="bottom"
							placeholder="GO Other contact"
							class="form-control multi-dropdown select_filter"
							selectLabel
							deselectLabel
							selectedLabel
							autocomplete="off"
							tagPlaceholder="Press enter to create new contact"
							style="max-height:40px;"
							:multiple="false"
							id="other"
							:taggable="true"
							@select = "addNew($event,'other', index)"
							@tag="addNew($event,'other', index)"
						>
							<template slot="noResult">
								<div @click="addNew('other', index)">Create new Other contact</div>
							</template>
						</multiselect>
					</div>
				</div>

				<div class="form-group row">
					<label class="col-sm-3 col-form-label">
						Partner UUID
						<!-- <sup>*</sup> -->
					</label>
					<div class="col-sm-7 pr-5">
							<input
							type="text"
							name="partner_uuid"
							v-model="clientData.partner_uuid"
							class="form-control"
							id="partner_uuid"
							placeholder="Partner UUID"
							autocomplete = "off"
							min="0"
							style="height:40px;"
						>
					</div>
				</div>

				<div class="form-group row">
					<label class="col-sm-3 col-form-label">
						Company Initiative
					</label>
					<div class="col-sm-7 pr-5">
						<multiselect
							v-model="clientData.go_initiative"
							:options="companyInitiatives"
							:searchable="true"
							ref="multiselect"
							open-direction="bottom"
							placeholder="GO Initiative"
							class="form-control multi-dropdown select_filter"
							selectLabel
							deselectLabel
							selectedLabel
							autocomplete="off"
							style="max-height:40px;"
							:multiple="false"
							id="companyInitiative"
						>
						
						</multiselect>
					</div>
				</div>

				<div class="form-group row">
					<label class="col-sm-3 col-form-label">
						SharePoint Files
					</label>
					<div class="col-sm-7 pr-5">
						<input
							type="text"
							name="sharePoint"
							v-model="clientData.sharepoint_link"
							class="form-control"
							id="sharePoint"
							placeholder="Link input to SharePoint"
							autocomplete = "off"
							style="height:40px;"
							@input="validateSharePoint"
						>
					</div>
					<span class="no-data-style ml-2 pl-1" v-if="!validUrl">
						Please check for valid sharepoint link.
					</span>
				</div>

				<AddNewClientPopUp
					:clientId="clientId"
					:type="type"
					:newClientName="newClientName"
					:oldClientCd="oldClientCd"
					@newClientInfo="newClientInfo"
					@closeSaveClient="closeSaveClient"
				/>
				<AddContactModal
					v-if="openAddNewContactModal"
					@closeAddContactModal="closeAddContactModal"
					:addedNewName="addedNewName"
					:editObj = "editObj"
				/>
			</form>
		</div>
	</div>
</template>

<script>

	import Multiselect from "vue-multiselect";
	import moment from "moment";
	import datePicker from "vue-bootstrap-datetimepicker";
	import AddNewClientPopUp from "./AddNewClientPopUp.vue";
	import AddContactModal from "@/components/account-management/AddContactModal";


	export default {
		name: "ClientData",
		props: [
			"openAddNewClientPopUp",
			"clientData",
			"clientList",
			"isLoadingClient",
			"client_disable"
		],
		components: {
			Multiselect,
			AddNewClientPopUp,
			AddContactModal
		},
		mounted() {
			this.getContactsList();
			if (this.openAddNewClientPopUp) {
				this.addNewClient("");
			}
		},
		watch: {
			openAddNewClientPopUp() {
				if (this.openAddNewClientPopUp) {
					this.addNewClient("");
				}
			}
		},
		data() {
			return {
				validUrl:true,
				newClientName: "",
				contacts_list: [],
				marketLoader: false,
				opsLoader: false,
				clientLoader: false,
				retailLoader: false,
				addedNewName: "",
				openAddNewContactModal: false,
				addedType: "",
				type:'',
				editObj:{},
				oldClientCd:null,
				companyInitiatives: ['Dominate','Drive','Deliver'],
				clientId:''
			};
		},
		computed: {},
		methods: {
			validateSharePoint(){
				let userInput = this.clientData.sharepoint_link;
				if(userInput==''){
					this.validUrl=true;
					return;
				}
				var res = userInput.match(/(http(s)?:\/\/.)[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g);
				if(res == null){
					this.validUrl = false;
				}
				else{
					this.validUrl = true;
				}
			},
					
			addNewClient(data,id,go_client_cd,type) {
				this.clientId = id
				this.type = type
				this.newClientName = data;
				this.oldClientCd = id ? go_client_cd : null
				$("#addclient").modal("show");
			},
			selectNewClient(data) {
				this.$emit("setClient", data.client_id);
			},
			newClientInfo(data) {
				this.clientData.client = data;
				this.$emit("updateClientWithNew", data);
			},
			closeSaveClient(data) {
				if (this.openAddNewClientPopUp && data == "cancel" && this.type!='edit') {
					this.$store.state.calledFromCancel = true;
					this.$router.push({ path: "/accounts" });
				}
				this.newClientName = ''
				this.type = ''
				this.clientId = ''
				this.oldClientCd = null
				$("#addclient").modal("hide");
			},
			getContactsList() {
				let payload = { q: "" };
				let vm = this;
				this.$store
					.dispatch("accounts/getContactsList", payload)
					.then(res => {
						vm.contacts_list = res;
					});
			},
			customLabel(data) {
				if (!data.last_name) {
					return data.first_name;
				} else {
					return data.first_name + " " + data.last_name;
				}
			},
			selectProfileName(val, type) {
				switch (type) {
					case "client":
						this.clientLoader = true;
						this.clientData.client_main_contact = JSON.parse(
							JSON.stringify(val)
						);
						this.clientLoader = false;
						break;
					case "market":
						this.marketLoader = true;
						this.clientData.go_marketing = JSON.parse(
							JSON.stringify(val)
						);
						this.marketLoader = false;
						break;
					case "ops":
						this.opsLoader = true;
						this.clientData.go_ops = JSON.parse(JSON.stringify(val));
						this.opsLoader = false;
						break;
					case "retail":
						this.retailLoader = true;
						this.clientData.go_retail = JSON.parse(JSON.stringify(val));
						this.retailLoader = false;
						break;
					case "brand":
						this.clientData.go_brand = JSON.parse(JSON.stringify(val))
						break;
					case "dsp":
						this.clientData.go_dsp = JSON.parse(JSON.stringify(val))
						break;
					case "media":
						this.clientData.go_retail = JSON.parse(JSON.stringify(val))
						break;
					case "content":
						this.clientData.go_marketing = JSON.parse(JSON.stringify(val))
						break;
					case "ba":
						this.clientData.go_ops = JSON.parse(JSON.stringify(val))
						break;
					case "other":
						this.clientData.go_retail = JSON.parse(JSON.stringify(val))
						break;
				}
			},
			addNew(val, type) {
				if(val && typeof val == "object"){
					this.editObj = val;
					this.addedNewName = val.first_name;
				}
				else{
					this.addedNewName = val;
				}
				this.openAddNewContactModal = true;
				this.addedType = type;
			},
			closeAddContactModal(data, type) {
				this.addedNewName = "";
				this.openAddNewContactModal = false;

				if (data.length) {
					switch (this.addedType) {
						case "client":
							this.clientData.client_main_contact = (type == 'reset' ? '' : data[0])
							break;
						case "market":
							this.clientData.go_marketing = (type == 'reset' ? '' : data[0])
							break;
						case "ops":
							this.clientData.go_ops = (type == 'reset' ? '' : data[0])
							break;
						case "retail":
							this.clientData.go_retail = (type == 'reset' ? '' : data[0])
							break;
						case "brand":
							this.clientData.go_brand = (type == 'reset' ? '' : data[0])
							break;
						case "dsp":
							this.clientData.go_dsp = (type == 'reset' ? '' : data[0])
							break;
						case "media":
							this.clientData.go_media = (type == 'reset' ? '' : data[0])
							break;
						case "content":
							this.clientData.go_content = (type == 'reset' ? '' : data[0])
							break;
						case "ba":
							this.clientData.go_ba = (type == 'reset' ? '' : data[0])
							break;
						case "other":
							this.clientData.go_other = (type == 'reset' ? '' : data[0])
							break;
					}
				}
				else{
					switch (this.addedType) {
						case "client":
							this.clientData.client_main_contact = null
							break;
						case "market":
							this.clientData.go_marketing = null
							break;
						case "ops":
							this.clientData.go_ops = null
							break;
						case "retail":
							this.clientData.go_retail = null
							break;
						case "brand":
							this.clientData.go_brand = null
							break;
						case "dsp":
							this.clientData.go_dsp = null
							break;
						case "media":
							this.clientData.go_media = null
							break;
						case "content":
							this.clientData.go_content = null
							break;
						case "ba":
							this.clientData.go_ba = null
							break;
						case "other":
							this.clientData.go_other = null
							break;
					}
				}
				
				if(type && type == 'edit'){
					let replaceVal = this.contacts_list.find((e) => e.id == data[0].id)
					if(replaceVal){
						let indx = this.contacts_list.indexOf(replaceVal)
						this.contacts_list.splice(indx, 1, data[0])
					}
				}
				else if (type == 'add'){
					this.contacts_list.push(data[0])
				}



				this.addedNewName = ''
				this.editObj = {}
			},
			updateName(query) {
				this.name = query;
			}
		}
	};
</script>

<style lang="scss">
</style>
